import React, { Component } from 'react'
import { connect } from 'react-redux'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import { injectIntl, FormattedMessage } from 'react-intl'
// Formatted text JSON map:



class InfoProfilePicture extends Component {
  render() {
    const { intl, isUKEnable } = this.props
    return (
      <div>
        <div className="container-fluid bg-white categories-info padding-6p">
          <div className="row">
            <div className="col-sm-12">
              <div className="close-icon">
                <a
                  href="javascript:void(0);"
                  aria-label="Click to close the info screen"
                  onClick={() => this.props.hideModal()}>
                  {' '}
                  X
                </a>
              </div>
              <h2>
                <FormattedMessage
                  id="infoProfilePicture.heading.profilePictureEvaluation"
                  defaultMessage="Profile Picture evaluation"
                />
              </h2>
              <div className="info-categories-icon">
                <img
                  alt={intl.formatMessage({ id: "infoProfilePicture.heading.profilePictureEvaluation", defaultMessage: "Profile Picture evaluation" })}
                  src={`${process.env.APP_BASE_URL}dist/images/info-profile-picture-evaluation-icon.jpg`}
                  width="60"
                />
              </div>
              <div className="info-right-data">
                <h3>
                  <FormattedMessage
                    id="infoProfilePicture.heading.factorsForPerfectProfilePicture"
                    defaultMessage="What factors to consider for perfect profile picture?"
                  />
                </h3>
                <p>
                  <FormattedMessage
                    id="infoProfilePicture.paragraph.profilePictureImportance"
                    defaultMessage="According to LinkedIn research, having a picture, by itself, makes your profile 14 times more likely to be viewed. It is your chance to have a good first impression on the Recruiter. Make sure that your picture is professional and has all the characteristics of a good image listed below."
                  />
                </p>
              </div>
              <div className="row margin-4p border-top-gray">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row profile-picture-evaluation">
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['face_frame']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.faceFrameRatio"
                            defaultMessage="FACE/FRAME RATIO"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.faceFrameRatio"
                            defaultMessage="A good image has a face/frame ratio of around 50%."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['face_body']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.faceBodyRatio"
                            defaultMessage="FACE/BODY RATIO"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.faceBodyRatio"
                            defaultMessage="In a good LinkedIn profile picture, your face covers a larger area as compared to your body."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4 img-margin img-width">
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-01.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-02.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-03.png`}
                        />
                      </div>
                    </div>
                    <div className="border-bottom-gray" />
                    <div className="row profile-picture-evaluation">
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl, isUKEnable)['profile_picture']['sample']['background']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.backgroundIllumination"
                            defaultMessage="BACKGROUND ILLUMINATION"
                          />
                          {' '}
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.backgroundIllumination"
                            defaultMessage="A good image has a light-{isUKEnable, select, true {coloured} other {colored}} background that helps to portray your picture clearly."
                            values={{ isUKEnable: isUKEnable ? 'true' : 'false' }}
                          />
                        </p>
                      </div>
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['foreground']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.foregroundIllumination"
                            defaultMessage="FOREGROUND ILLUMINATION"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.foregroundIllumination"
                            defaultMessage="Ensure that shadows and other reflections do not interfere with the clarity and prominence of your face."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4 img-margin img-width">
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-04.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-05.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-06.png`}
                        />
                      </div>
                    </div>
                    <div className="border-bottom-gray" />
                    <div className="row profile-picture-evaluation">
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['eye']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.eyeContact"
                            defaultMessage="EYE CONTACT"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.eyeContact"
                            defaultMessage="One should make an eye contact with the camera. This portrays confidence in the person."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4">&nbsp;</div>
                      <div className="col-sm-4 img-margin img-width">
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-07.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-08.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-09.png`}
                        />
                      </div>
                    </div>
                    <div className="border-bottom-gray" />
                    <div className="row profile-picture-evaluation">
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['smile']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.smileDetection"
                            defaultMessage="SMILE DETECTION"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.smileDetection"
                            defaultMessage="An open smile increases likeability and is a feature in almost all good LinkedIn profile pictures."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4">&nbsp;</div>
                      <div className="col-sm-4 img-margin img-width">
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-10.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-11.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-12.png`}
                        />
                      </div>
                    </div>
                    <div className="border-bottom-gray" />
                    <div className="row profile-picture-evaluation">
                      <div className="col-sm-4">
                        <h5
                          tabIndex={0}
                          aria-label={infoScreenAriaLabel(intl)['profile_picture']['sample']['size']}
                        >
                          <FormattedMessage
                            id="infoProfilePicture.heading.photoSize"
                            defaultMessage="PHOTO SIZE"
                          />
                        </h5>
                        <p>
                          <FormattedMessage
                            id="infoProfilePicture.paragraph.photoSize"
                            defaultMessage="Photo size should be between 400 x 400 and 20K x 20K pixels for optimum picture clarity."
                          />
                        </p>
                      </div>
                      <div className="col-sm-4">&nbsp;</div>
                      <div className="col-sm-4 img-height">
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-13.png`}
                        />
                        <img
                          alt=""
                          src={`${process.env.APP_BASE_URL}dist/images/group-14.png`}
                        />
                      </div>
                    </div>
                    <div className="border-bottom-gray" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isUKEnable: state.aspireFeedbackData.ukEnglish,
  }
}

export default connect(mapStateToProps)(injectIntl(InfoProfilePicture))
